function Footer() {
  return (
    <div className="footer">
      <footer><a href='https://joshua-langner.com'> ©2022 Joshua Langner WebDev · All Rights Reserved </a></footer>
    </div>
  )
}

export default Footer